import { useMemo } from "react";

import { IntlShape } from "react-intl";

import DateRangeType from "@mapmycustomers/shared/enum/DateRangeType";
import DateRangeOptionGroup from "@mapmycustomers/shared/types/range/DateRangeOptionGroup";

import getOptions from "@app/component/input/dateRangeSelect/utils/getOptions";
import { weekRangesGenerator } from "@app/component/input/dateRangeSelect/utils/rangesGenerator";
import DateRange from "@app/scene/reports/types/DateRange";
import { formatDate } from "@app/util/formatters";

const getOptionGroupLabel = (intl: IntlShape, range: DateRange) =>
  formatDate(
    range.startDate,
    intl.formatMessage({
      id: "dateRangeSelector.week.groupTitle",
      defaultMessage: "LLLL yyyy",
      description: "Date format for options group in the Leaderboard's range selector for weeks",
    })
  );

export const getOptionLabel = (intl: IntlShape, range: DateRange, short?: boolean) =>
  intl.formatMessage(
    {
      id: "dateRangeSelector.week.option",
      defaultMessage: "{start} — {end}",
      description: "Title of week options in the Leaderboard's range selector",
    },
    {
      end: formatDate(
        range.endDate,
        intl.formatMessage(
          {
            id: "dateRangeSelector.week.option.end",
            defaultMessage: "{short, select, true {MMM d} other {eeee, MMM d}}",
            description: "End date format for week options in the Leaderboard's range selector",
          },
          { short }
        )
      ),
      start: formatDate(
        range.startDate,
        intl.formatMessage(
          {
            id: "dateRangeSelector.week.option.start",
            defaultMessage: "{short, select, true {MMM d} other {eeee, MMM d}}",
            description: "Start date format for week options in the Leaderboard's range selector",
          },
          { short }
        )
      ),
    }
  );

const useWeekOptions = (intl: IntlShape, fromDate?: Date): DateRangeOptionGroup[] =>
  useMemo(
    () =>
      getOptions(
        intl,
        DateRangeType.WEEK,
        weekRangesGenerator(fromDate),
        (range) => `${range.startDate.getFullYear()}}-${range.startDate.getMonth()}`,
        getOptionGroupLabel,
        getOptionLabel
      ),
    [intl, fromDate]
  );

export default useWeekOptions;
